import React from 'react';
import looppa from 'looppa';
import PropTypes from 'prop-types';
import Icon from 'components/icon';
import { NavLink } from 'react-router-dom';
import { t, Trans } from 'translations';
import staticPath from 'util/misc/static-assets-path';
import { legalAndPrivacy, social } from 'constants/menus';

export default function FooterTail({ hasAdditionalContent, hasAgbLink, tabIndex }) {
    return (
        <footer className="footer-tail">
            <div className="footer-tail--row grid--row">
                <div className="footer-tail--col footer-tail--logo grid--col">
                    <figure className="footer-tail--figure">
                        <img src={staticPath('img/logos/logo_87x16_migros.svg')} alt={t('migros.title')}/>
                    </figure>
                    <small className="footer-tail--copyright"><Trans path="footer.copyright"
                        data={{ year: new Date().getFullYear() }}/></small>
                </div>
                {hasAdditionalContent && <nav className="footer-tail--col footer-tail--social grid--col">
                    <ul className="footer-tail--social-list u-reset">
                        {looppa(social())(({ url, title, symbol }) => (
                            <li className="footer-tail--social-item" key={symbol}>
                                <a tabIndex={tabIndex} className="footer-tail--social-link u-reset" href={url}
                                    title={t(title)} target="_blank"
                                    rel="noreferrer noopener">
                                    <Icon symbol={symbol} size="large"/>
                                </a>
                            </li>
                        ))}
                    </ul>
                    <div className="footer-tail--row grid--row">
                        <nav className="footer-tail--links-wrapper grid--col">
                            <ul className="footer-tail--links-list u-reset">
                                {hasAgbLink && looppa(legalAndPrivacy())(({ url, title }, i) => (
                                    <li className="footer-tail--links-item" key={i}>
                                        <NavLink target="_blank" tabIndex={tabIndex} activeClassName="footer-tail--link__is-active"
                                            className="footer-tail--link u-reset" exact to={url}>{title}</NavLink>
                                    </li>
                                ))}
                                <li className="footer-tail--links-item">
                                    <a tabIndex={tabIndex} className="footer-tail--link u-reset" href={t('privacy.url')}
                                        target="_blank">
                                        <Trans path="privacy.title"/>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </nav>}
            </div>
        </footer>
    );
}

FooterTail.propTypes = {
    tabIndex: PropTypes.number.isRequired,
    hasAdditionalContent: PropTypes.bool.isRequired,
    hasAgbLink: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-footer/footer-tail/index.js